import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { ReverificationSubmitByVerifierStaffModalForm } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';
import { useCurrentUserVerifier } from 'src/hooks/verifier';

import { ReverificationSubmitByVerifierStaffModalArgs } from './types';

export const ReverificationSubmitByVerifierStaffModal: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { isOpen, args, closeModal, switchClosability } =
    useModal<ReverificationSubmitByVerifierStaffModalArgs>(
      ModalId.ReverificationSubmitByVerifierStaff,
    );

  const { isGovernmentVerifier } = useCurrentUserVerifier();

  const handleModalClose = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => handleModalClose()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [handleModalClose]);

  if (!args?.inboxItemId) {
    return null;
  }

  const renderHeaderText = () => {
    if (isGovernmentVerifier) {
      return isMobile ? 'Verification' : 'Confirm you want to submit a request again';
    }
    return isMobile ? 'Reverification' : 'Confirm you want to submit reverification';
  };

  return (
    <Modal
      title={renderHeaderText()}
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{ open: isOpen, onClose: handleModalClose, fullScreen: isMobile }}
      maxWidth={640}
      headerPadding="32px 32px 5px"
    >
      <ReverificationSubmitByVerifierStaffModalForm
        closeModal={handleModalClose}
        switchClosability={switchClosability}
        inboxItemId={args.inboxItemId}
      />
    </Modal>
  );
};
